import { createRouter, createWebHistory } from 'vue-router'
import LoginView from '@/views/LoginView.vue'
import RegisterView from '@/views/RegisterView.vue'
import { useStorage } from 'vue3-storage'

const storage = useStorage()
const routes = [
  {
    path: '/',
    name: 'home',
    redirect: () => {
      const isAuthenticated = !!storage.getStorageSync('loggedUser')
      const loginType = storage.getStorageSync('loginType')

      // TODO: fix routing, la propiedad data.data.admin siempre es 0, no se puede validar el rol

      if (!isAuthenticated) {
        return { name: 'login' }
      }

      if (loginType === 'admin') {
        return { path: '/admin/usuarios' }
      }

      return { name: 'catalog' }
    }
  },
  {
    path: '/admin/usuarios',
    name: 'admin-users',
    component: () => import('@/views/Admin/AdminUsersView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/catalogo',
    name: 'admin-catalog',
    component: () => import('@/views/Admin/AdminCatalogView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/web-minorista',
    name: 'admin-web-minorista',
    component: () => import('@/views/Admin/AdminWebMinoristaView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/web-jp',
    name: 'admin-web-jp',
    component: () => import('@/views/Admin/AdminWebJpView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/mercadolibre',
    name: 'admin-mercadolibre',
    component: () => import('@/views/Admin/AdminMercadoLibreView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/tienda-nube',
    name: 'admin-tienda-nube',
    component: () => import('@/views/Admin/AdminTiendaNubeView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/data-entry',
    name: 'admin-data-entry',
    component: () => import('@/views/Admin/AdminDataEntryView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/estadisticas',
    name: 'admin-stats',
    component: () => import('@/views/Admin/AdminStatsView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/banners',
    name: 'admin-banners',
    component: () => import('@/views/Admin/AdminBannersView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/pedidos',
    name: 'admin-orders',
    component: () => import('@/views/Admin/AdminOrdersView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/reclamos',
    name: 'admin-claims',
    component: () => import('@/views/Admin/AdminClaimsView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/subir',
    name: 'admin-upload',
    component: () => import('@/views/Admin/AdminUploadView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/chat',
    name: 'admin-chat',
    component: () => import('@/views/Admin/AdminChatView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/contabilidad',
    name: 'admin-contabilidad',
    component: () => import('@/views/Admin/AdminContabilidadView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/configuracion',
    name: 'admin-settings',
    component: () => import('@/views/Admin/AdminSettingsView.vue'),
    meta: { layout: 'admin' }
  },
  {
    path: '/admin/login',
    name: 'admin-login',
    component: () => import('@/views/AdminLoginView.vue'),
    meta: { layout: 'admin-login' }
  },
  {
    // Link del mail de "Olvidé mi contraseña" (?email=&token=).
    path: '/admin/restablecer-password',
    name: 'admin-reset-password',
    component: () => import('@/views/AdminResetPasswordView.vue'),
    meta: { layout: 'admin-login' }
  },
  {
    path: '/catalogo-clasico',
    name: 'catalog-clasic',
    component: () => import('@/views/CatalogView.vue')
  },
  {
    path: '/catalogo',
    name: 'catalog',
    component: () => import('@/views/CatalogV2View.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/catalogo-cards',
    name: 'catalog-cards',
    component: () => import('@/views/CatalogV3View.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/pedidos',
    name: 'orders',
    component: () => import('@/views/OrdersView.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/carrito',
    name: 'cart',
    component: () => import('@/views/CartView.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    // El link a un producto abre el catálogo con el slide del producto abierto
    // (antes iba a una página aparte, ProductView, que quedó en desuso).
    path: '/producto/:id',
    name: 'product',
    component: () => import('@/views/CatalogV2View.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: { layout: 'login' }
  },
  {
    path: '/registro',
    name: 'register',
    component: RegisterView,
    meta: { layout: 'login' }
  },
  {
    path: '/perfil',
    name: 'profile',
    component: () => import('@/views/ProfileView.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/descargas',
    name: 'downloads',
    component: () => import('@/views/DownloadsView.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/reclamos',
    name: 'claims',
    component: () => import('@/views/ClaimsView.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/cuenta-corriente',
    name: 'account',
    component: () => import('@/views/AccountView.vue'),
    meta: { layout: 'sidebar' }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('@/views/NotFoundView.vue')
  }
]

const baseUrl = process.env.VITE_BASE_URL || '/'
const router = createRouter({
  history: createWebHistory(baseUrl),
  routes
})
const isAuthenticated = !!storage.getStorageSync('loggedUser')

router.beforeEach((to, from, next) => {
  const allowedRoutes = [
    'login',
    'admin-login',
    'admin-reset-password',
    'register',
    'forgotPassword',
    'resetPassword'
  ]

  if (!allowedRoutes.includes(to.name) && !isAuthenticated) {
    // Link directo al admin (ej. desde el mail de precios): login de admin y,
    // después, volver a esa misma dirección.
    if (to.path.startsWith('/admin')) {
      try { sessionStorage.setItem('volverA', to.fullPath) } catch (e) { /* sin storage */ }
      next({ name: 'admin-login' })
      return
    }
    next({ name: 'login' })
  } else {
    next()
  }
})

export default router
